import Cookie from 'js-cookie'
export default{
	state:{
		isCollapse:false, //控制菜单展开收起
		menucolor:'#19191e', //菜单颜色
		textcolor:'#fff', //文字颜色
		tabsList:[
			{
					path: '/home',
					name: 'home',
					label: '首页',
					icon: 'el-icon-s-home',
					url: 'Home/Home'
			}
		],//面包屑数据
		menu:[
			{
					path: '/home',
					name: 'home',
					label: '首页',
					icon: 'el-icon-s-home',
					url: 'Home/Home'
				}
		] //左侧导航列表
	},
	mutations:{
		//修改菜单展开收起的方法
		collapseMenu(state){
			state.isCollapse = !state.isCollapse
		},
		//修改菜单颜色风格
		changemenucolor(state){
			state.menucolor == state.menucolor? state.menucolor = '#fff':state.menucolor = '#19191e'
		},
		
		changetextcolor(state){
			state.textcolor == state.textcolor? state.textcolor = '#19191e':state.textcolor = '#19191e'
		},
		//更新面包屑数据
		selectMunu(state,val){
			if(val.name !== 'home'){
				const index = state.tabsList.findIndex(item => item.name === val.name)
				if (index === -1) {
					state.tabsList.push(val)
				} 
			}
		},
		closetag(state,item){
			const index = state.tabsList.findIndex(val =>val.name === item.name)
			state.tabsList.splice(index,1)
		},
		//获取菜单列表
		setmenu(state,item){
			state.menu = item
			Cookie.set('menu',JSON.stringify(state.menu))
		},
		//动态注册路由
		addmenu(state,router){
			if(!Cookie.get('menu'))return
			const menu = JSON.parse(Cookie.get('menu'))
			state.menu = menu
			const menuArray = []
			// console.log(menu);
			menu.forEach(item=>{
				if(item.children){
					item.children = item.children.map(item=>{
						item.component = () =>import(`../views/${item.url}`)
						return item
					})
					menuArray.push(...item.children)
				}else{
					item.component = () =>import(`../views/${item.url}`)
					menuArray.push(item)
				}
			})
			// console.log(menuArray);
			//路由动态添加
			menuArray.forEach(item=>{
				router.addRoute('main',item)
			})
			
		}
	}
}